import React, { useCallback } from 'react';
import { route } from '../../../../../services/utils';
import { LIVESTOCK_ANIMALS_AND_EVENTS_INDEX } from '../../../../../router/routes';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Form from '../../../../../components/form';
import Table from '../../../../../components/common/table/table';
import useFormBody from './use-form-body';
import useFormTop from '../use-form-top';
import { useCreateFooter } from '../use-create-footer';
import { usePregnancyCheckState } from './use-pregnancy-state';
import { usePregnancyStore } from './use-pregnancy-store';
import { schema } from './pregnancySchema';
import { AnimalEventAnimal } from '../../../../../interfaces/animal-event';
import TableVerticalSizeFixer from '../../../../../components/common/table/table-vertical-size-fixer/table-vertical-size-fixer';
import AnimalType from '../../../../../enums/animal-type';
import AnimalsAndEventsTabsKeys from '../../enums/animals-and-events-tab-keys';
import animalEventFormCss from '../animal-events-form.module.css';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup/dist/yup';

export default function CreatePregnancy() {
  const { farmId } = useParams<{
    farmId: string;
  }>();

  const { t } = useTranslation();

  const transKeyPrefix = 'pages.livestock.animals_and_events.';
  const tp = useCallback(
    (key: string, params?: { [key: string]: string | number }) =>
      t(transKeyPrefix.concat(key), params),
    [t]
  );

  const footer = useCreateFooter();
  const [otherState, animals, removeRow, addRow] = usePregnancyCheckState();
  const body = useFormBody();
  const top = useFormTop({ addRow, eventType: AnimalType.pregnancy });
  const submit = usePregnancyStore(animals);
  const formMethods = useForm({
    resolver: yupResolver(schema(tp)),
    mode: 'onChange',
    reValidateMode: 'onChange',
  });

  formMethods.setValue('animals', animals);

  return (
    <Form
      backTo={route(LIVESTOCK_ANIMALS_AND_EVENTS_INDEX, {
        tab: AnimalsAndEventsTabsKeys.animals,
        farmId,
      })}
      schema={schema(tp)}
      title={tp('animals.types.pregnancy')}
      body={body}
      top={top}
      footer={footer}
      mode={'create'}
      submit={submit}
      values={otherState}
      className={animalEventFormCss['animal_event_form']}
      formMethods={formMethods}
    >
      <TableVerticalSizeFixer>
        <Table<AnimalEventAnimal>
          data={animals}
          keyAccessor="id"
          onRemove={removeRow}
          filteredTotalsParams={{
            recordName: 'pages.livestock.animals_and_events.events.table_title',
            fullText: { tp, key: 'events.table_title' },
          }}
          paginate={false}
          showRemove={true}
          columns={[
            {
              accessor: 'animal_id',
              header: tp('events.grazing.id'),
              sortable: false,
              className: 'animal_id',
            },
            {
              accessor: 'name',
              header: tp('events.grazing.name'),
              sortable: false,
              className: 'name',
            },
            {
              accessor: 'insemination',
              header: tp('events.insemination'),
              sortable: false,
              className: 'name',
            },
          ]}
        />
      </TableVerticalSizeFixer>
    </Form>
  );
}
